module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/snackbar/snackbar.component.css
// module id = ./src/app/snackbar/snackbar.component.css
// module chunks = main